var _rect, _path, _line, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasteYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 141,
    viewBox: "0 0 226 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 41,
    width: 100,
    height: 100,
    fill: "url(#pattern0_4159_27078)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 0.5C189.722 0.5 202.122 4.22754 211.077 10.2275C220.036 16.2297 225.5 24.4673 225.5 33.5C225.5 42.5327 220.036 50.7703 211.077 56.7725C202.122 62.7725 189.722 66.5 176 66.5C162.278 66.5 149.878 62.7725 140.923 56.7725C131.964 50.7703 126.5 42.5327 126.5 33.5C126.5 24.4673 131.964 16.2297 140.923 10.2275C149.878 4.22754 162.278 0.5 176 0.5Z",
    fill: "white",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 146.367,
    y1: 54.3391,
    x2: 134.367,
    y2: 67.3391,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.073 25.784H174.353V40.248H173.073V25.784ZM167.073 31.304H170.705V32.392H167.073V31.304ZM170.161 26.12H171.425V39.512H170.161V26.12ZM162.609 35.656H163.537C165.793 35.656 167.153 35.592 168.753 35.256L168.881 36.36C167.233 36.712 165.841 36.776 163.537 36.776H162.609V35.656ZM162.609 27.544H168.049V28.632H163.921V36.088H162.609V27.544ZM187.712 25.784H188.976V35.944H187.712V25.784ZM183.488 30.264H185.68V31.352H183.488V30.264ZM185.072 26.008H186.336V34.84H185.072V26.008ZM176.72 27.576H183.888V28.632H176.72V27.576ZM180.288 29.368C182.048 29.368 183.296 30.424 183.296 31.992C183.296 33.576 182.048 34.632 180.288 34.632C178.544 34.632 177.296 33.576 177.296 31.992C177.296 30.424 178.544 29.368 180.288 29.368ZM180.288 30.392C179.216 30.392 178.48 31.032 178.48 31.992C178.48 32.952 179.216 33.608 180.288 33.608C181.392 33.608 182.112 32.952 182.112 31.992C182.112 31.032 181.392 30.392 180.288 30.392ZM179.632 25.912H180.96V28.296H179.632V25.912ZM183.52 35.336H184.64V35.688C184.64 38.12 181.984 39.768 179.024 40.2L178.56 39.16C181.136 38.84 183.52 37.432 183.52 35.688V35.336ZM183.696 35.336H184.832V35.688C184.832 37.432 187.216 38.84 189.792 39.16L189.328 40.2C186.368 39.768 183.696 38.12 183.696 35.688V35.336Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 87,
    r: 6,
    fill: "url(#paint0_radial_4159_27078)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 120.5,
    r: 12.5,
    fill: "url(#paint1_radial_4159_27078)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 129.5,
    r: 5.5,
    fill: "url(#paint2_radial_4159_27078)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 7.5,
    fill: "url(#paint3_radial_4159_27078)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 110,
    r: 9,
    fill: "url(#paint4_radial_4159_27078)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 96.5,
    r: 4.5,
    fill: "url(#paint5_radial_4159_27078)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4159_27078",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4159_27078",
    transform: "scale(0.00239808)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.24 87.24) rotate(92.3859) scale(5.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 121) rotate(92.3859) scale(12.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.72 129.72) rotate(92.3859) scale(5.28458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8 100.8) rotate(92.3859) scale(7.20625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.36 110.36) rotate(92.3859) scale(8.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4159_27078",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.68 96.68) rotate(92.3859) scale(4.32375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F4D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F185",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4159_27078",
    width: 417,
    height: 417,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteYellow);
export default __webpack_public_path__ + "static/media/Taste_Yellow.5127845112e550f896f254b492c53743.svg";
export { ForwardRef as ReactComponent };